const NOT_BASE64 = /[^A-Z0-9+\/=]/i;

/**
 * O(n) iterative base64 validator that avoids the catastrophic-backtracking
 * regex in both validator.js (`@IsBase64()`) and Zod (`z.string().base64()`),
 * which throw `RangeError: Maximum call stack size exceeded` on multi-MB
 * inputs.
 *
 * @see https://github.com/validatorjs/validator.js/issues/2573
 */
export function isLikelyBase64(value: unknown): boolean {
    if (typeof value !== "string") {
        return false;
    }

    if (value.length === 0) {
        return false;
    }
    if (value.length % 4 !== 0) {
        return false;
    }

    if (NOT_BASE64.test(value)) {
        return false;
    }

    // The regex above already guarantees only [A-Za-z0-9+/=] remain.
    // Validate that '=' only appears at the very end (max 2 pad chars).
    const firstPad = value.indexOf("=");
    if (firstPad !== -1) {
        const padLength = value.length - firstPad;
        if (padLength > 2) {
            return false;
        }
        if (value.substring(firstPad) !== "=".repeat(padLength)) {
            return false;
        }
    }

    return true;
}
